module.exports = __webpack_public_path__ + "img/portal-icon.5093a982.svg";